import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  Store as StoreIcon,
  Person as PersonIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { shopAPI } from '../services/api';

const DashboardPage = () => {
  const { agent, isAdmin } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [stats, setStats] = useState({
    totalShops: 0,
    loading: true,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await shopAPI.getShops();
        setStats({
          totalShops: response.count || 0,
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
        setStats({ totalShops: 0, loading: false });
      }
    };

    fetchStats();
  }, []);

  const StatCard = ({ icon, title, value, color }) => (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              backgroundColor: `${color}.light`,
              color: `${color}.main`,
              borderRadius: 2,
              p: { xs: 1.5, sm: 2 },
            }}
          >
            {icon}
          </Box>
          <Box>
            <Typography variant={isMobile ? "h5" : "h4"} component="div">
              {value}
            </Typography>
            <Typography variant="body2" color="text.secondary" fontSize={isMobile ? "0.75rem" : "0.875rem"}>
              {title}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
      <Typography variant={isMobile ? "h5" : "h4"} gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Welcome back, {agent?.name}!
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            icon={<StoreIcon fontSize={isMobile ? "medium" : "large"} />}
            title="Total Shops"
            value={stats.loading ? '...' : stats.totalShops}
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            icon={<PersonIcon fontSize={isMobile ? "medium" : "large"} />}
            title="Role"
            value={agent?.role || 'N/A'}
            color="secondary"
          />
        </Grid>
        {isAdmin() && (
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              icon={<AdminIcon fontSize={isMobile ? "medium" : "large"} />}
              title="Admin Access"
              value="Enabled"
              color="success"
            />
          </Grid>
        )}
      </Grid>

      <Paper sx={{ p: { xs: 2, sm: 3 }, mt: 3 }}>
        <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
          Account Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">
              Name
            </Typography>
            <Typography variant="body1">{agent?.name}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body1">{agent?.email}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">
              Role
            </Typography>
            <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
              {agent?.role}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
            <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
              {agent?.status}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DashboardPage;


